import { cx } from '@mage-ui/styled-system/css';
import { focus, footer, text } from '@mage-ui/styled-system/recipes';
import Link from 'next/link';

export const FooterPolicy = ({ data, texts, ...props }) => {
  const links = data?.relations?.Links || [];
  return (
    <div className={footer().policyWrapper} {...props}>
      {texts.copyright} | {texts.location}
      <ul className={footer().policy}>
        {links?.map((item) => (
          <li key={item?.meta?.key}>
            <Link
              href={item?.meta?.link || '#'}
              className={cx(
                text({ size: '3', weight: 'medium' }),
                footer().link,
                focus(),
              )}
            >
              {item?.fields?.title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
